module.exports = __webpack_public_path__ + "static/media/flatlogo.ab608cdc.svg";